export default {
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    onlyOnMobile(string) {
      return this.isMobile ? string : undefined;
    },
    onlyOnDesktop(string) {
      return this.isMobile ? undefined : string;
    },
  },
};
